import script from "./UserView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserView.vue?vue&type=script&setup=true&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=05a34fba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a34fba"]])

export default __exports__